import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

export const XngSetUserFields: typeof SetUserFields = props => {
    const { parameter, result } = props;
    if (!result.updatedUser) {
        throw new Error("There was no editingUser set and we are trying to update it.");
    }

    const canViewArProps= (parameter as {canViewAr?: string}).canViewAr;
    result.updatedUser = {
            ...result.updatedUser,
            properties: {
                ...result.updatedUser.properties,
                canViewAr:  typeof canViewArProps !== "undefined" ? canViewArProps : result.updatedUser.properties["canViewAr"]
            }
    }
}

addToChainAfter(chain, SetUserFields, XngSetUserFields)